import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import { TextField } from 'ui_system/forms/FormStyles';
import { t } from 'services/translation';

const CurrencySymbol = styled.span`
  color: #777;
  left: 10px;
  position: absolute;
  top: 15px;
`;

const StyledNumberFormat = styled(NumberFormat)`
  ${TextField}
  padding-left: 25px;
`;

const PriceInput = (props) => {
  const { onChange, field } = props;
  const handlePricingChange = (e) => {
    onChange('price', e.target.value);
  };

  return (
    <React.Fragment>
      <CurrencySymbol>$</CurrencySymbol>
      <StyledNumberFormat
        decimalSeparator="."
        allowNegative={false}
        placeholder={t('INPUT_PRICE')}
        decimalScale={2}
        fixedDecimalScale
        onChange={handlePricingChange}
        onBlur={handlePricingChange}
        onFocus={(event) => event.target.select()}
        value={field.value}
        isNumericString
      />
    </React.Fragment>
  );
};
export default PriceInput;

PriceInput.propTypes = {
  field: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
